import v from "./ghl-ui.es703.js";
import h from "./ghl-ui.es799.js";
function x(a, r, i, d) {
  var l = !i;
  i || (i = {});
  for (var g = -1, s = r.length; ++g < s; ) {
    var n = r[g], f = d ? d(i[n], a[n], n, i, a) : void 0;
    f === void 0 && (f = a[n]), l ? h(i, n, f) : v(i, n, f);
  }
  return i;
}
export {
  x as default
};
